const comments = [
  {
    name: '影视达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20man%20with%20a%20friendly%20smile%2C%20casual%20style%2C%20clean%20background%2C%20warm%20lighting%2C%20professional%20headshot%20style%2C%20natural%20pose%2C%20modern%20portrait%20photography&width=100&height=100&seq=avatar-1-91movie&orientation=squarish',
    role: '资深用户 · 使用2年',
    text: '试过很多看片APP，91精品影视是我用过最稳定的。片源更新快，画质也好，关键是没有乱七八糟的广告弹窗。现在追剧就靠它了，强烈推荐！',
    rating: 5,
  },
  {
    name: '追剧小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20woman%20with%20a%20bright%20smile%2C%20casual%20everyday%20look%2C%20simple%20neutral%20background%2C%20soft%20natural%20lighting%2C%20friendly%20and%20approachable%20headshot%20photography%2C%20modern%20portrait%20style&width=100&height=100&seq=avatar-2-91movie&orientation=squarish',
    role: 'VIP会员 · 使用1年',
    text: '离线下载这个功能太实用了！每天通勤路上看两集剧，完全不费流量。AI推荐也很准，经常能发现一些冷门好片，已经安利给身边所有朋友了。',
    rating: 5,
  },
  {
    name: '电影发烧友老张',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle-aged%20Chinese%20man%20with%20glasses%20and%20a%20warm%20confident%20smile%2C%20business%20casual%20attire%2C%20clean%20minimal%20background%2C%20professional%20headshot%20with%20soft%20studio%20lighting%2C%20trustworthy%20and%20friendly%20expression&width=100&height=100&seq=avatar-3-91movie&orientation=squarish',
    role: '电影爱好者 · 使用3年',
    text: '从V1.0版本就在用了，看着APP一步步优化到现在。现在的4K专区画质真的太震撼了，配个好耳机完全是家庭影院级别的体验。国产良心产品！',
    rating: 5,
  },
  {
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20woman%20with%20a%20playful%20and%20energetic%20expression%2C%20trendy%20casual%20style%2C%20bright%20clean%20background%20with%20soft%20warm%20lighting%2C%20modern%20youthful%20headshot%20photography%2C%20friendly%20and%20vibrant%20personality&width=100&height=100&seq=avatar-4-91movie&orientation=squarish',
    role: '动漫迷 · 使用半年',
    text: '动漫专区太全了！新番更新速度和日本同步，国漫优质作品也都有。画面清晰度比网页版好太多了，周末一口气刷完一季超满足。',
    rating: 4,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-white">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            用户评价
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            听听真实用户怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-5xl mx-auto">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-50 rounded-2xl border border-secondary-100 p-5 md:p-6">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-secondary-200">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-heading font-semibold text-foreground-900 text-sm">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.role}</div>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <i
                      key={j}
                      className={`text-xs ${j < c.rating ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-foreground-200'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <div className="inline-flex items-center gap-6 text-sm text-foreground-500">
            <span>
              <strong className="text-primary-600 font-bold">4.8</strong> 综合评分
            </span>
            <span className="text-foreground-200">|</span>
            <span>
              <strong className="text-foreground-900 font-bold">1.2万+</strong> 用户评价
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}